// @flow
import URI from 'urijs';

import { appQueryParameters, url as urlUtils } from '@clubmed/utils';
import { isStrictlyIntegrationEnv, isStrictlyStagingEnv } from 'Utils/context/contextUtils';

import type { ProductChildcareAvailabilitiesProps } from 'Components/widgets/product/Product.mapper';
import type { ProductComparisonProps } from 'Components/widgets/product/product-comparison/ProductComparison';
import type { ProductFlagProps } from 'Components/widgets/product/product-flag/ProductFlag';
import type { ProductHeaderProps } from 'Components/widgets/product/product-header/ProductHeader';
import type { OfferDiscountProps } from 'Components/widgets/offer-discount/OfferDiscount';
import type { ProductThumbnailProps } from 'Components/widgets/product/product-thumbnail/ProductThumbnail';

export const grid: ScreenSizesProps = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3,
};

export type ProductProps = {|
  callToAction?: {
    label?: string,
  },
  childcare?: ProductChildcareAvailabilitiesProps,
  className?: string,
  comparison?: ProductComparisonProps,
  flag?: ProductFlagProps,
  hasComparison?: boolean,
  hasDiscount?: boolean,
  header: ProductHeaderProps,
  id: string,
  isLinkDisabled?: boolean,
  offerDiscount?: OfferDiscountProps,
  thumbnail?: ProductThumbnailProps,
  type: string,
  url?: string,
  hasLazyLoading?: boolean,
  shouldFadeInLong?: boolean,
|};
export const generateProductLink = (url: string, offer?: ?Offer = {}): string => {
  return offer && offer.seoName
    ? new URI(url)
        .addSearch(appQueryParameters.shopping.offer, urlUtils.encodePath(offer.seoName))
        .toString()
    : url;
};
export const generateLinkProp = (url?: string, offer?: Offer) => {
  return url
    ? { url: generateProductLink(url, offer), queryParamsToIgnore: offer ? [] : ['offer'] }
    : undefined;
};
export const generateCmtaLinkProp = (url?: string, originalUrl?: string) => {
  let resortName = '';
  let domain = 'clubmed.com';
  const subDomain = 'travelagents';

  const resortMatch = url && url.match(/\/r\/(.*)\//);
  if (resortMatch) {
    resortName = resortMatch[1];
  }

  const domainMatcher = originalUrl && originalUrl.match(/(clubmed\.[\.\w]+)\//);
  if (domainMatcher) {
    domain = domainMatcher[1];
  }

  let cmtaUrl = `https://${subDomain}.${domain}`;

  if (isStrictlyIntegrationEnv()) {
    cmtaUrl = `https://${subDomain}.integ.${domain}`;
  }
  if (isStrictlyStagingEnv()) {
    cmtaUrl = `https://${subDomain}.staging.${domain}`;
  }

  const cmtaFullUrl = new URI(cmtaUrl).path(`/resort/${resortName}/`);
  return {
    url: cmtaFullUrl.toString(),
    isExternalLink: true,
  };
};
